import { render, staticRenderFns } from "./notificationBarItem.vue?vue&type=template&id=57a09b0e&"
import script from "./notificationBarItem.vue?vue&type=script&lang=js&"
export * from "./notificationBarItem.vue?vue&type=script&lang=js&"
import style0 from "./notificationBarItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports